import { useMemo } from 'react';
import MetricCard from '../shared/MetricCard';
import Badge from '../shared/Badge';
import DataTable from '../shared/DataTable';
import EmptyState from '../shared/EmptyState';
import { formatMoney } from '../../utils/formatters';

export default function MissingInvoices({ data }) {
  const items = data?.items || [];

  const posted = items.filter((m) => m.ro_status_id === 5 || m.ro_status_id === 6 || m.ro_status === 'Posted');
  const totalCost = data?.total_cost_usd || items.reduce((s, m) => s + (m.cost_usd || 0), 0);

  const columns = useMemo(() => [
    {
      key: 'part_name',
      label: 'Part',
      render: (row) => (
        <div>
          <div className="font-bold text-sm">{row.part_name || row.partName}</div>
          <div className="text-xs text-gray-400">{row.part_number || row.partNumber}</div>
        </div>
      ),
    },
    {
      key: 'ro_number',
      label: 'RO #',
      render: (row) => (
        <div>
          <div className="font-semibold text-sm">#{row.ro_number || row.roNumber}</div>
          <div className="text-xs text-gray-400">{row.customer_name || row.customer}</div>
        </div>
      ),
    },
    { key: 'vehicle', label: 'Vehicle', render: (row) => <span className="text-xs">{row.vehicle_description || row.vehicle}</span> },
    { key: 'job_name', label: 'Job', render: (row) => <span className="text-xs text-gray-500">{row.job_name || row.jobName}</span> },
    {
      key: 'cost_usd',
      label: 'Cost',
      align: 'right',
      render: (row) => <span className="font-bold">{formatMoney(row.cost_usd || row.cost / 100)}</span>,
    },
    {
      key: 'retail_usd',
      label: 'Retail',
      align: 'right',
      render: (row) => <span className="text-gray-400">{formatMoney(row.retail_usd || row.retail / 100)}</span>,
    },
    {
      key: 'ro_status',
      label: 'Status',
      render: (row) => {
        const isPosted = row.ro_status_id === 5 || row.ro_status === 'Posted';
        return <Badge severity={isPosted ? 'critical' : 'warning'} text={row.ro_status || 'Unknown'} />;
      },
    },
  ], []);

  return (
    <div>
      <div className="flex gap-3 mb-6 flex-wrap">
        <MetricCard
          label="Parts Without PO"
          value={items.length.toString()}
          sub="No purchase order linked"
          accent="#C62828"
          icon={'\uD83D\uDCCB'}
        />
        <MetricCard
          label="Untracked Cost"
          value={formatMoney(totalCost)}
          sub="Cost not in vendor AP"
          accent="#E65100"
          icon={'\uD83D\uDCB0'}
        />
        <MetricCard
          label="On Posted ROs"
          value={posted.length.toString()}
          sub="Already billed to customer"
          accent="#D32F2F"
          icon={'\u26A0'}
        />
      </div>

      {items.length > 0 ? (
        <DataTable columns={columns} data={items} />
      ) : (
        <EmptyState text="No missing invoices found" />
      )}
    </div>
  );
}
